module.exports = __webpack_public_path__ + "img/ma-logo.6809313d.svg";